import {DEVICE_SIZES} from 'rn-responsive-styles';

export const getSize = (deviceSize: DEVICE_SIZES) => {
  switch (deviceSize) {
    case DEVICE_SIZES.EXTRA_SMALL_DEVICE:
      return 540;
    case DEVICE_SIZES.SMALL_DEVICE:
      return 768;
    case DEVICE_SIZES.MEDIUM_DEVICE:
      return 992;
    case DEVICE_SIZES.LARGE_DEVICE:
      return 1200;
    default:
      return 0;
  }
};
